import React from 'react';

import ListWithTitle from 'components/ListWithTitle/ListWithTitle';
import SafetyAcademyPreview from 'features/safety-academy/Preview/SafetyAcademyPreview';

import './SafetyAcademyOverview.scss';
import { POSTS_TYPES, TRANSLATIONS } from 'types/enums';
import { selectUser } from 'store/selectors/user.selectors';
import { useSelector } from 'react-redux';

import { Supply_User_Roles, useGetPostsQuery } from 'generated/graphql';
import LoadingSpinner from 'components/LoadingSpinner';
import { useTranslation } from 'react-i18next';
import { userIsAssigner, userIsExecutor } from 'utils/shared/canUserAccessFeature';

type Props = { fromHome?: boolean };

const SafetyAcademyOverview = ({ fromHome = false }: Props) => {
  const { t } = useTranslation();
  const { loading, data } = useGetPostsQuery({
    variables: { limit: 10, type: POSTS_TYPES.NEWS as any },
  });
  const userData = useSelector(selectUser);

  if (userData?.getIn(['roleDetails', 'slug']) === Supply_User_Roles.CorporateSupply
  || userIsExecutor(userData?.getIn(['roleDetails', 'slug']), userData?.get('type'))
  || userIsAssigner(userData?.getIn(['roleDetails', 'slug']), userData?.get('type'))) return null;

  const news = data?.getPosts?.posts;

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="safety-academy-overview">
      <div className="col-9 card">
        <SafetyAcademyPreview />
      </div>
      <div className="col-3 card" style={fromHome ? { marginTop: '-108px' } : undefined}>
        <ListWithTitle
          text={t(TRANSLATIONS.SAFETY_NEWS)}
          list={news as any}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default SafetyAcademyOverview;
